import { EServiceStatus } from 'constants/service';
import { IApiPagination } from './common';

export interface IMerchant {
  id: number;
  merchantCode: string;
  merchantBrand: string;
  merchantName: string;
  businessType: string;
  type: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  address: string;
  status?: string;
  locationId: string;
  fullAddress: string;
  mccVnpay?: string;
  billingCode: string | null;
  providerId?: string;
  businessCert?: string;
  domainCert?: string;
  otherDocument?: string;
  taxCert?: string;
  isExportBilling?: boolean;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  extraData?: string;
  accountantContactName?: string;
  accountantContactEmail?: string;
  accountantContactPhone?: string;
  crossCheckContactName?: string;
  crossCheckContactEmail?: string;
  crossCheckContactPhone?: string;
  crossCheckContactAddress?: string;
  crossCheckContractNumber?: string;
  crossCheckContractSignedAt?: string;
  representerName?: string | null;
  representerGender?: string | null;
  representerDob: string | null;
  representerNational: string | null;
  representerTypeOfId?: string | null;
  representerNumberOfId: string | null;
  representerDateOfIssue: string | null;
  representerPlaceOfIssue: string | null;
  representerIdCert?: string;
  representerCert?: string;
  ewalletPhone: string;
  appUser: string;
  taxCode?: string;
  passportExpiredAt: string | null;
  visaExpiredAt: string | null;
  approvalStatus: string;
  cttStatus?: EServiceStatus;
  qrStatus?: EServiceStatus;
  sposStatus?: EServiceStatus;
  defaultTerminalId?: number;
  potentialType: string;
  countTerminal: number;
  services: string;
  debtAccountManagementPhone?: string;
  isNotUsingVnpayWallet?: boolean;
  isCrossSale?: boolean;
  transactionManagementEmailAccount?: string;
  agentContract?: string;
}

export interface IMerchantResponse {
  code: string;
  message: string;
  data: {
    merchant: IMerchant;
  };
}

export interface ILockMerchantParams {
  merchant_id: number;
  status: number;
  note?: string;
}

export interface IMerchantInShop {
  merchant_id: number;
  merchant_brand: string;
  merchant_code: string;
  merchant_name: string;
  merchant_status?: string;
}

export interface IMerchantCreate {
  merchant_code: string;
  merchant_name: string;
  merchant_brand: string;
  type: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  location_id: string;
  address: string;
  full_address: string;
  business_type: string;
  provider_id: string;
  business_cert: string;
  representer_cert: string;
  domain_cert: string;
  other_document: string;
  billing_code: string;
  tax_cert: string;
  is_export_billing: boolean;
  representer_name: string;
  representer_gender: string;
  representer_dob: string;
  representer_national: string;
  representer_type_of_id: string;
  representer_number_of_id: string;
  representer_date_of_issue: string;
  representer_place_of_issue: string;
  representer_id_cert: string;
  extra_data: string;
  app_user: string;
  tax_code: string;
  ewallet_phone: string;
  potential_type: string;
}

export interface IMerchantCreate {
  merchant_code: string;
  merchant_name: string;
  merchant_brand: string;
  type: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  location_id: string;
  address: string;
  full_address: string;
  business_type: string;
  provider_id: string;
  business_cert: string;
  representer_cert: string;
  domain_cert: string;
  other_document: string;
  billing_code: string;
  tax_cert: string;
  is_export_billing: boolean;
  representer_name: string;
  representer_gender: string;
  representer_dob: string;
  representer_national: string;
  representer_type_of_id: string;
  representer_number_of_id: string;
  representer_date_of_issue: string;
  representer_place_of_issue: string;
  representer_id_cert: string;
  extra_data: string;
  app_user: string;
  tax_code: string;
  ewallet_phone: string;
}

export interface IParamSearchMerchant {
  searchText?: string;
  merchantStatus?: string;
  withLastestTicket?: boolean;
  pageSize: number;
  page: number;
}

export interface IMerchantBFF {
  id: number;
  type: string;
  merchantCode?: string;
  merchantName?: string;
  businessType?: string;
  contactPhone?: string;
  approvalStatus?: string;
  fullAddress?: string;
  services?: string;
  lastestTicket?: {
    content: string;
    createAt: string;
    staff: {
      id: number;
      fullName: string;
      email: string;
    };
    team: {
      id: number;
      teamName: string;
    };
    customerInterestedService?: string;
  };
  departmentMerchantName?: string;
  adminMerchantDepartmentName?: string;
}

export interface IMerchantBFFResponse {
  code: string;
  message: string;
  data?: {
    merchant: IMerchantBFF[];
    pagination: {
      currentPage: number;
      pageSize: number;
      totalItems: number;
    };
  };
}

export interface IShopOfMerchant {
  id: number;
  shopName: string;
  fullAddress: string;
  status: string;
  potentialType: string;
  locationId?: string;
  address?: string;
  contactPhone?: string;
  isDefault?: boolean;
  businessTypes?: {
    code: string;
    name: string;
  }[];
  isShopChain?: boolean;
  images?: string;
  services: {
    id: number;
    name: string;
  }[];
  ticket: {
    status: number;
    content: string;
    customerInterestedService?: string;
    issueType: number;
    date: string;
    staff: {
      id: number;
      name: string;
      email: string;
    };
    team: {
      id: number;
      teamName: string;
    };
  };
  addressUrl: string;
  logoImage: string;
}

export interface IShopOfMerchantResponse {
  code: string;
  message: string;
  data: {
    shops: IShopOfMerchant[];
    pagination: {
      currentPage: number;
      pageSize: number;
      totalItems: number;
    };
  };
}

export interface IShopDetailResponse {
  code: string;
  message: string;
  data: IShopOfMerchant;
}

export interface IMerchantDetail {
  id: number;
  type: string;
  merchantCode: string;
  merchantSubCode: string;
  businessCert?: string;
  taxCode?: string;
  merchantName: string;
  merchantBrand: string;
  businessType: string;
  address?: string;
  fullAddress: string;
  representerName: string;
  representerNumberOfId?: string | null;
  representerTypeOfId?: string;
  representerDateOfIssue?: string;
  representerPlaceOfIssue?: string;
  representerGender?: string;
  representerNational?: string | null;
  representerDob?: string;
  contactPhone: string;
  contactEmail: string;
  ewalletPhone: string;
  appUser: string;
}

export interface IMerchantDetailResponse {
  merchant: IMerchantDetail;
}

export enum IMerchantStatus {
  APPROACHING = 'approaching',
}

export interface IGetMerchantApproachingParams {
  latestApproachingStatus?: number[];
  merchantId?: number[];
  page?: number;
  pageSize?: number;
}

export interface IMerchantApproachingProcess {
  id: number;
  merchantName: string;
  merchantCode: string;
  createdAt: string;
  businessType: string;
  businessName: string;
  opportunityAmount: number;
  stageScore: number;
  totalShop: number;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  flagStatus: number;
}

export interface IGetMerchantApproachingResponse {
  approachingMerchants: IMerchantApproachingProcess[];
  pagination: IApiPagination;
}

export interface IUpdateMerchantApproaching {
  opportunityAmount?: number;
  flagStatus?: number;
}

export interface IMerchantApproachHistory {
  ticketId: number;
  issueTypeId: number;
  issueTypeName: string;
  createdAt: string;
  processingStatusCloseAt: string;
  internalProcessNote: string;
  staffId: number;
  staffEmail: string;
  teamId: number;
  teamName: string;
}
